var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractTypes from "./abstract";
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super.call(this) || this;
        _this.filter_type = 'select';
        return _this;
    }
    Select.prototype.renderInput = function (rule) {
        var filter = rule.getFilter();
        if (filter.input !== 'select' || filter.use_ajax) {
            return;
        }
        var settings = {
            width: 150,
            theme: 'acs2',
        };
        if (Object.keys(filter.values).length < 10) {
            settings.minimumResultsForSearch = -1;
        }
        var $element = rule.$el;
        $element.find('.rule-value-container select').select2(settings);
    };
    Select.prototype.transformFilter = function (filter) {
        if (typeof filter.values === 'object') {
            filter.input = 'select';
        }
        return filter;
    };
    return Select;
}(AbstractTypes));
export default Select;
